import {useState} from "react";
import Icon from "../selfcare/Icon.tsx";
import {saveRmo} from "../../util/request.ts";
import {Link} from "react-router-dom";
import {CallMeStatus, PushCallMeEvent} from "../gtm/Events.ts";
import Routing from "../../Routing.ts";
import IconArrow from "../icons/IconArrow.tsx";
import {CallMeQueue} from "../../util/callMe.ts";

export default function CallMeFormComponent(props: {onSubmitForm?: () => void, queue?: CallMeQueue}) {
    const [name, setName] = useState<string>("")
    const [number, setNumber] = useState<string>("")

    const [numberError, setNumberError] = useState<boolean>(false)
    const [submitting, setSubmitting] = useState<boolean>(false)
    const [submissionSuccess, setSubmissionSuccess] = useState<boolean>(false)
    const [submissionError, setSubmissionError] = useState<boolean>(false)

    if (submitting) {
        return (
            <div className={'form-message'}>
                <h4 className={'heading heading--montserrat heading--medium'}>Sender din besked</h4>
                <div className="form__loader"></div>
            </div>
        )
    }

    if (submissionSuccess) {
        return (
            <div className={'form-message'}>
                <h4 className={'heading heading--montserrat heading--medium'}>Tak</h4>
                <p>Vi har registreret din henvendelse og vil kontakte dig hurtigst muligt.</p>
            </div>
        )
    }

    if (submissionError) {
        return (
            <div className={'form-message'}>
                <h4 className={'heading heading--montserrat heading--medium'}>
                    Der er desværre opstået en fejl
                </h4>
                <p>
                    <Link to={Routing.Contact.Index}>Kontakt os</Link> venligst via chat eller telefon, så vi kan hjælpe dig videre.
                </p>
            </div>
        )
    }

    return (
        <form className="call-me-form flex flex-row flex-center">
            <div className="grid flex flex-row flex-center">
                <div className="item hide-on-small-devices">
                    <input
                        type="text"
                        placeholder="Indtast navn"
                        value={name}
                        onChange={(v) => setName(v.target.value)}
                    />
                </div>
                <div className="item">
                    <input
                        type="tel"
                        autoComplete={"tel"}
                        name={"phone"}
                        className={numberError ? "error" : ""}
                        placeholder="Indtast nummer"
                        value={number}
                        onChange={(v) => setNumber(v.target.value)}
                    />
                </div>
                <div className="item">
                    <label id="submit-form-button">
                        <input
                            disabled={submitting}
                            className="continue-button-submit"
                            type="submit"
                            onClick={(e) => {
                                e.preventDefault()
                                const cleanedNumber = number.replaceAll(" ", '')
                                if (cleanedNumber.length < 8) {
                                    setNumberError(true)
                                    return
                                } else {
                                    setNumberError(false)
                                }

                                setSubmitting(true)

                                if (props.onSubmitForm !== undefined) {
                                    props.onSubmitForm()
                                }

                                saveRmo(name, cleanedNumber, props.queue).then((r) => {
                                    let callMeStatus
                                    if (r.code === 201) {
                                        callMeStatus = CallMeStatus.Ok
                                        setSubmissionSuccess(true)
                                    } else {
                                        callMeStatus = r.code < 500
                                            ? CallMeStatus.NotSent
                                            : CallMeStatus.Error

                                        setSubmissionError(true)
                                        setSubmissionSuccess(false)
                                    }

                                    PushCallMeEvent(props.queue, r.response.hph1, r.response.hph2, callMeStatus)
                                })
                                .catch(() => {
                                    setSubmissionError(true)
                                }).finally(() => {
                                    setSubmitting(false)
                                })
                            }}
                        />
                        <Icon component={IconArrow} className={"continue-button"}/>
                    </label>
                </div>
            </div>
        </form>
    )
}
